import React from "react";
import { projects } from "../content";
import AnmolCareer from "../assets/Projects/AnmolCareer.png";
import ShopIt from "../assets/Projects/ShopIt.png";
import LetMeHandle from "../assets/Projects/LetMeHandle.png";
import {
  Github,
  Globe,
  ArrowUpRight,
  CoverWellness,
  CoverAi,
  CoverHealth,
} from "./Icons";

const imageMap = { AnmolCareer, ShopIt, LetMeHandle };
const coverMap = { wellness: CoverWellness, ai: CoverAi, health: CoverHealth };

const ProjectCard = ({ name, image, cover, github, website, tags, desc }) => {
  const Cover = coverMap[cover];
  const src = imageMap[image];

  return (
    <article className="card card--interactive project">
      <div className="project-visual">
        {src ? (
          <img src={src} alt={`${name} screenshot`} loading="lazy" />
        ) : (
          <div className="project-cover">{Cover && <Cover />}</div>
        )}
      </div>

      <div className="project-body">
        <div className="project-head">
          <h3 className="project-name">{name}</h3>
          <div className="project-links">
            {github && (
              <a
                className="icon-link"
                href={github}
                target="_blank"
                rel="noreferrer"
                aria-label={`${name} on GitHub`}
              >
                <Github />
              </a>
            )}
            {website && (
              <a
                className="icon-link"
                href={website}
                target="_blank"
                rel="noreferrer"
                aria-label={`${name} live site`}
              >
                <Globe />
              </a>
            )}
          </div>
        </div>

        <p className="project-desc">{desc}</p>

        <div className="project-foot">
          <div className="tag-row">
            {tags.map((t) => (
              <span className="tag" key={t}>
                {t}
              </span>
            ))}
          </div>

          {(website || github) && (
            <a
              className="link-arrow"
              href={website || github}
              target="_blank"
              rel="noreferrer"
            >
              {website ? "Visit site" : "View source"}
              <ArrowUpRight />
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

const Projects = () => (
  <section id="projects" className="section section--sunken section--ruled">
    <div className="shell">
      <div className="section-head">
        <p className="eyebrow">Selected work</p>
        <h2 className="section-title">Things I've built</h2>
        <p className="section-lede">
          A platform I founded, an AI system built at an internal hackathon, and
          a few projects from along the way.
        </p>
      </div>

      <div className="projects-grid reveal">
        {projects.map((p) => (
          <ProjectCard key={p.id} {...p} />
        ))}
      </div>
    </div>
  </section>
);

export default Projects;
